module.exports = __webpack_public_path__ + "static/media/notification.fde9b392.svg";